import { makeStyles } from "tss-react/mui";
import {
  ICONS_WEB,
  ICON_VARIANTS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { DialogTitle, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { MiButton } from "../MiButton/MiButton";
import { MiIcon } from "../MiIcon/MiIcon";

export function ModalHeader({
  title,
  titleIcon,
  titleContainerStyle,
  closeModal,
  loading,
}) {
  const { classes, theme } = useStyles();

  return (
    <DialogTitle className={classes.titleSection} style={titleContainerStyle}>
      <Box className={classes.titleLeftSection}>
        {titleIcon && (
          <MiIcon
            path={titleIcon.path}
            color={titleIcon.color || theme.palette.primary.main}
            variant={titleIcon?.variant || ICON_VARIANTS.CONTAINED}
            size={0.8}
            style={{
              marginRight: theme.spacing(2),
            }}
            data-testid="title-icon"
          />
        )}
        <Typography
          className={classes.title}
          variant={TYPOGRAPHY_VARIANTS.LIST_TITLE}
        >
          {title}
        </Typography>
      </Box>
      <MiButton
        onClick={closeModal}
        startIcon={{
          path: mdi[ICONS_WEB.CLOSE],
          iconSize: 0.8,
          iconColor: theme.palette.grey.main,
        }}
        style={{
          padding: theme.spacing(1),
          borderRadius: "50%",
        }}
        disabled={loading}
        data-testid="close-modal-button"
      />
    </DialogTitle>
  );
}

const useStyles = makeStyles()((theme) => ({
  titleSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.grey.lightAccent,
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.grey.accent}`,
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
  },
  titleLeftSection: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: theme.palette.bluegrey.dark,
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.large,
  },
}));
